import type { ChatRoomResponseLastMessageBasicInfo } from './chatRoomResponseLastMessageBasicInfo';
import type { ChatRoomResponseLastMessageSender } from './chatRoomResponseLastMessageSender';
import type { ChatRoomResponseLastMessageStatus } from './chatRoomResponseLastMessageStatus';

/**
 * 마지막 메시지
 */
export type ChatRoomResponseLastMessage = {
  basicInfo?: ChatRoomResponseLastMessageBasicInfo;
  /** 발신자 정보 */
  sender?: ChatRoomResponseLastMessageSender;
  /** 메시지 상태 정보 */
  status?: ChatRoomResponseLastMessageStatus;
};
